export const PUSH_CHECKIN = 'PUSH_CHECKIN'
export const RESET_CHECKINS = 'RESET_CHECKINS'
export const PUSH_THOUGHT = 'PUSH_THOUGHT'
export const RESET_THOUGHTS = 'RESET_THOUGHTS'
export const SET_CHECKIN_THOUGHT_LOADING = 'SET_CHECKIN_THOUGHT_LOADING'